import { invokeApi } from "../../bl_libs/invokeApi";

export const attendance_roster_api = async (classId, signal = null) => {
  return invokeApi({
    path: `api/attendances/class/${classId}/roster`,
    method: "GET",
    signal,
  });
};

export const attendance_filter_options_api = async (classId, signal = null) => {
  return invokeApi({
    path: `api/attendances/class/${classId}/filter-options`,
    method: "GET",
    signal,
  });
};

export const attendance_month_api = async (classId, year, month, signal = null) => {
  return invokeApi({
    path: `api/attendances/class/${classId}`,
    method: "GET",
    queryParams: { year: String(year), month: String(month) },
    signal,
  });
};

export const attendance_list_api = async (classId, filters = {}, signal = null) => {
  const queryParams = {};
  if (filters.year != null) queryParams.year = String(filters.year);
  if (filters.month != null) queryParams.month = String(filters.month);
  if (filters.start_date) queryParams.start_date = String(filters.start_date);
  if (filters.end_date) queryParams.end_date = String(filters.end_date);
  if (filters.class_period_id) queryParams.class_period_id = String(filters.class_period_id);

  return invokeApi({
    path: `api/attendances/class/${classId}`,
    method: "GET",
    queryParams,
    signal,
  });
};

export const attendance_bulk_save_api = async (classId, postData) => {
  return invokeApi({
    path: `api/attendances/class/${classId}`,
    method: "POST",
    postData,
  });
};

export const attendance_patch_attendee_api = async (
  attendanceId,
  studentId,
  postData,
) => {
  return invokeApi({
    path: `api/attendances/session/${attendanceId}/attendees/${studentId}`,
    method: "PATCH",
    postData,
  });
};

export const attendance_delete_attendee_api = async (attendanceId, studentId) => {
  return invokeApi({
    path: `api/attendances/session/${attendanceId}/attendees/${studentId}`,
    method: "DELETE",
    postData: {},
  });
};

export const attendance_delete_session_api = async (attendanceId) => {
  return invokeApi({
    path: `api/attendances/session/${attendanceId}`,
    method: "DELETE",
    postData: {},
  });
};
